export const classifyMixins = {
  data() {
    return {
      formData: {
        id: null,
        name: "",
        parentId: 0,
      },
      rules: {
        name: [
          {
            required: true,
            message: "请输入",
            trigger: ["blur", "change"],
          },
        ],
        parentId: [
          {
            required: true,
            message: "请选择",
            trigger: ["blur", "change"],
          },
        ],
      },
    };
  },

  methods: {
    clearForm() {
      this.formData.id = null;
      this.formData.name = "";
      this.formData.parentId = Number(
        this.$Base64.decode(this.$route.params.id)
      );
    },
    async handleConfirm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          await this.saveClassTree({
            ...this.formData,
          });
          if (this.formData.id) {
            this.$message.success("编辑成功");
          } else {
            this.$message.success("新增成功");
          }
          await this.$router.push({ name: "ClassifyManagement" }, () => {});
        }
      });
    },
  },
};
